export class ChamberEntrepreneurshipRequest {
  body: ChamberEntrepreneurshipRequestBody = new ChamberEntrepreneurshipRequestBody();
}

export class ChamberEntrepreneurshipRequestBody {
  ProcessName = 'DC Community Portal SR Process Wrapper WF';
  DCMethod = 'SAVEASDRAFT';
  DCLanguage = 'ENU';
  DCLoginName = '';
  DCIncomingHierarchy: ChamberEntrepreneurshipHierarchy =
    new ChamberEntrepreneurshipHierarchy();
}

export class ChamberEntrepreneurshipHierarchy {
  MessageId = '';
  IntObjectName = 'DCDCEIO';
  MessageType = 'Integration Object';
  IntObjectFormat = 'Siebel Hierarchical';
  ['ListOfDCDCEIO']: {
    'Service Request': ChamberEntrepreneurshipServiceRequest;
  } = {
    'Service Request': new ChamberEntrepreneurshipServiceRequest()
  };
}

export class ChamberEntrepreneurshipServiceRequest {
  CSN = '';
  'Created By First Name' = '';
  'Created By Last Name' = '';
  'Created By Name' = '';
  'SR Type' = 'Chamber Entrepreneurs';
  'SR Sub Type' = 'Chamber Entrepreneurs';
  'SR Number' = '';
  'DC BGBCAssoc Venue' = ''; // Emirates ID
  'DC Holder Mobile' = ''; // Mobile No
  'DC CRB Primary Email' = ''; // Email
  'DC SVS Other Member Number' = ''; // Member No
  'DC Respondent Member Name' = ''; // Member name Eng
  'DC Respondant Name Ara' = ''; // Member name Ara
  'DC Respondant Country' = ''; // Nationality
  'DC License Issue Date' = ''; // License Issue Date
  'DC License Expiry Date' = ''; // License Expiry Date
  Description = ''; // Brief Description of company
  'DC FAC No of Guest' = ''; // No of employee
  'DC Kiosk Print Flag' = ''; // Do you have another trade license in UAE
  'DC MRM Website' = ''; // Website
  'DC Account Holder' = ''; // Account Holder Name
  'DC Holder Bank Name' = ''; // Bank Name
  'DC BGBCAssoc Bank Accnt Num' = ''; // Account Number
  'DC IBAN No' = ''; // IBAN
  'DC Swift Code' = ''; // Swift code
  'DC FAC Insurance Amt' = ''; // trade license pay
  'DC FAC Amt Pre Discount' = ''; // visa pay
  'DC Amount in AED' = ''; // utility pay
  'DC CSR Mail Flag' = ''; // Do you need access to free vat
  'DC Additional Detail' = ''; // Market insight revelant
  'DC Reprint Sticker Flag' = ''; // Are you interested in attending AI
  'ListOfDC DCE Question BC'?: ChamberEntrepreneurshipQuestionList | null;
}

export class ChamberEntrepreneurshipQuestionList {
  'DC DCE Question BC'?: ChamberEntrepreneurshipQuestionItem[] | null = [];
}

export class ChamberEntrepreneurshipQuestionItem {
  'DC Support Type' = '';
  'DC Question' = '';
  'ListOfDC DCE Inkind Support BC' = new ChamberEntrepreneurshipInkindList();
}

export class ChamberEntrepreneurshipInkindList {
  'DC DCE Inkind Support BC': ChamberEntrepreneurshipInkindItem[] = [];
}

export class ChamberEntrepreneurshipInkindItem {
  'DC Value En' = '';
  'DC Value Ar' = '';
}
